import axios, { AxiosError } from 'axios'
import { AppStatus } from '~concierge/types/IdentityTypes'

export const BASE_API_PATH = '/api/alfred/forms'

export class IdentityService {
  private static appStatus: AppStatus

  static async fetchAppStatus(): Promise<AppStatus> {
    if (!this.appStatus) {
      try {
        const response = await axios.get(BASE_API_PATH + '/status')
        this.appStatus = response.data as AppStatus
      } catch (error: unknown | Error | AxiosError) {
        throw error
      }
    }
    return this.appStatus
  }

  static async getAppStatus(): Promise<AppStatus> {
    if (!this.appStatus) {
      this.appStatus = await this.fetchAppStatus()
    }
    return this.appStatus
  }
}
